import { render, staticRenderFns } from "./EmployeeResume.vue?vue&type=template&id=25fa3e00&scoped=true"
import script from "./EmployeeResume.vue?vue&type=script&lang=js"
export * from "./EmployeeResume.vue?vue&type=script&lang=js"
import style0 from "./EmployeeResume.vue?vue&type=style&index=0&id=25fa3e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa3e00",
  null
  
)

export default component.exports